var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _vm.organizationUnitId } })],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _vm.id && _vm.user
      ? _c("div", { staticClass: "container" }, [
          _c("h4", { staticClass: "fg-color-blue" }, [
            _vm._v(
              _vm._s(_vm.displayName) +
                " belongs to organization " +
                _vm._s(_vm.organizationUnitName)
            ),
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("table", { staticClass: "table table-striped table-hover" }, [
            _c(
              "tbody",
              _vm._l(_vm.organizationUnits, function (ou) {
                return _c("tr", [
                  _c("th", [_vm._v(_vm._s(ou.Name))]),
                  _vm._v(" "),
                  _c("td", [
                    ou.OrganizationUnitId == _vm.organizationUnitId
                      ? _c("span", [
                          _c("i", {
                            staticClass: "fa fa-check-circle fg-color-green",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(
                            "\n                            Current\n                        "
                          ),
                        ])
                      : _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.handleChangeOrganizationUnitCommandV1(
                                  ou
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                            Move to\n                        "
                            ),
                          ]
                        ),
                  ]),
                ])
              }),
              0
            ),
          ]),
        ])
      : !_vm.id
      ? _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "input-group mb-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.emailinput,
                  expression: "emailinput",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "email", placeholder: "Find user by email" },
              domProps: { value: _vm.emailinput },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.emailinput = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group-append" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.handleFindUser },
                },
                [_vm._v("Find")]
              ),
            ]),
          ]),
        ])
      : _c("div", { staticClass: "container" }, [
          _c("h4", [_vm._v("Email '" + _vm._s(_vm.id) + "' not found")]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Manage user's organization")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-link btn-sm",
              attrs: { href: "/#/admin/organizations/manage" },
            },
            [
              _c("i", {
                staticClass: "fa fa-arrow-left",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Back")]),
            ]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }